<template>

<div>
    <div>
      <b-button
        v-if="canEdit && !isControllingVideo && !isControlled"
        style="margin-bottom: 10px"
        variant="msstreamblue"
        block
        @click="controlVideo()"
        title="Take control of the video for all collaborators"
      >
        Take Control
        <font-awesome-icon :icon="['fas', 'hand-rock']"> </font-awesome-icon>
      </b-button>
    </div>

    <div>
      <b-button
        v-if="canEdit && isControllingVideo"
        style="margin-bottom: 10px"
        variant="greenw"
        block
        @click="releaseControlVideo()"
        title="Release control of the video for all collaborators"
      >
        Release Control
        <font-awesome-icon :icon="['fas', 'hand-paper']"> </font-awesome-icon>
      </b-button>
    </div>

    <div>
      <b-button
        v-if="canEdit && isControlled"
        style="margin-bottom: 10px"
        variant="msstreamblue"
        block
        disabled
        @click="releaseControlVideo()"
      >
        Take Control
        <font-awesome-icon :icon="['fas', 'hand-rock']"> </font-awesome-icon>
      </b-button>
    </div>

    <div
      v-if="canEdit"
      class="mb-1"
      style="border-radius: 5px; background-color: #f2f2f2"
    >
      <b-button
        variant="msstreamblue"
        v-if="!annVisible"
        block
        @click="annotationMode()"
        title="Add annotations to the video"
      >
        New annotation
        <font-awesome-icon :icon="['fas', 'highlighter']" transform="flip-h">
        </font-awesome-icon>
      </b-button>
      <b-button
        variant="greenw"
        v-else
        block
        @click="annotationMode()"
        title="Add annotations to the video"
      >
        New annotation
        <font-awesome-icon :icon="['fas', 'highlighter']" transform="flip-h">
        </font-awesome-icon>
      </b-button>

      <b-row class="m-0 mb-3 p-1 align-items-center">
        <b-col cols="12" style="text-align:center" v-if="annVisible">
          <div :class="pluginOptions.meta.user_name + '-color'" style="margin:5px">
            <strong>{{pluginOptions.meta.user_name}}</strong> -
            <small>
              now&nbsp
              <strong style="color:#2F90B0"> | {{startRange}}-{{endRange}}</strong>
            </small>
          </div>
        </b-col>

        <b-col cols="10" id="annBox" v-if="annVisible" class="transition-ease-in-out p-0 m-0">
          <b-form-textarea
            class="annotation"
            solo
            label="Message"
            v-model="annValue"
            :rules="['Required']"
            hide-details
            style="margin-top: 5px"
          ></b-form-textarea>
        </b-col>
        <b-col
          cols="2"
          v-if="annVisible"
          class="transition-ease-in-out p-0"
          style="text-align: center"
        >
          <b-button variant="empty" @click="addAnnotation()">
            <font-awesome-icon
              style="color: #14bf98"
              :icon="['fas', 'check']"
            />
          </b-button>
          <b-button variant="empty" @click="cancelAnnotationMode()">
            <font-awesome-icon style="color: red" :icon="['fas', 'times']" />
          </b-button>
        </b-col>
      </b-row>
    </div>

    <div class="commList">
      <div
        v-for="(ann, idx) in annotations"
        :key="idx"
        class="comment-list"
        :class="
          activeAnnotations.includes(ann) === true
            ? 'activeComment'
            : 'inactiveComment'
        "
        @mouseover="hoverAnnotation(ann, false)"
        @mouseleave="hoverAnnotation(ann, true)"
        style="margin-bottom: 10px"
      >

        <div style="padding:1px; border-radius:4px; background-color: #f2f2f2" >
        <b-row
        class="annotations transition-ease-in-out align-items-center pb-0"
        v-bind:style="'opacity:' + ((hiddenAnnotations.includes(ann.id) || !selectedPeople.includes(ann.commentList.comments[0].meta.user_name)) ? '.3;' : '1;')"
        >
          <b-col class="text-break m-0 p-0" @click="selectAnnotation(ann)" style="cursor: pointer">
            <span class="font-weight-bold" :class="ann.commentList.comments[0].meta.user_name + '-color'">
              {{ ann.commentList.comments[0].meta.user_name }} 
            <small>
              - {{ann.commentList.comments[0].timeSince}}
              <strong v-if="ann.range.end !== undefined && ann.range.end !== ann.range.start" style="color:#2F90B0" title="Start time - end time of annotation">
                | {{ fancyDurationFormat(ann.range.start) }}-{{ fancyDurationFormat(ann.range.end) }}&nbsp
                <span v-if="ann.shape" title="An area is selected on the video for this annotation"><font-awesome-icon :icon="['fas', 'dice-one']" /></span>
              </strong>
              <strong v-else style="color:#2F90B0" title="Start time - end time of annotation">
                | {{ fancyDurationFormat(ann.range.start) }}-{{ fancyDurationFormat(ann.range.stop) }}&nbsp
                <span v-if="ann.shape" title="An area is selected on the video for this annotation"><font-awesome-icon :icon="['fas', 'dice-one']" /></span>
              </strong>
            </small>
            </span>
          </b-col>
          <b-col cols="1">
            <b-icon 
            class="pointerEltSB"
            v-if="hiddenAnnotations.includes(ann.id)"
            @click="hideAnnotation(ann.id)"
            icon="eye-slash-fill"
            :style="activeAnnotations.includes(ann) === true ? {color:'#14BF98'}:{}"
            title="Annotation hidden on the video, click to make it visible"
            ></b-icon>

            <b-icon 
            class="pointerEltSB"
            v-if="!hiddenAnnotations.includes(ann.id)"
            @click="hideAnnotation(ann.id)"
            icon="eye-fill"
            :style="activeAnnotations.includes(ann) === true ? {color:'#14BF98'}:{}"
            title="Annotation visible on the video, click to hide"
            ></b-icon>
          </b-col>
          <b-col v-if="pluginOptions.meta.user_name === ann.commentList.comments[0].meta.user_name || ['admin', 'owner'].includes(userRole)"
          cols="1"
          @click="deleteAnnotation(ann.id)"
          >
            <font-awesome-icon class="pointerEltSB" style="color: red" :icon="['fas', 'trash']" title="Remove annotation" />
          </b-col>
        </b-row>
        
        <b-row
        class="annotations text-break transition-ease-in-out pt-0"
        @click="selectAnnotation(ann)"
        style="cursor:pointer"
        v-bind:style="'opacity:' + ((hiddenAnnotations.includes(ann.id) || !selectedPeople.includes(ann.commentList.comments[0].meta.user_name)) ? '.3;' : '1;')"
        >
          {{ ann.commentList.comments[0].body }}
        </b-row>
        </div>

        <b-row class="align-items-center m-1"
        v-bind:style="'opacity:' + ((hiddenAnnotations.includes(ann.id) || !selectedPeople.includes(ann.commentList.comments[0].meta.user_name)) ? '.3;' : '1;')"
        >
          <b-col cols="3">
            <div style="border-bottom:1px solid #2a5d77; margin:0px 5px" :style="activeAnnotations.includes(ann) === true ? {borderColor:'#14BF98'}:{}" ></div>
          </b-col>
          <b-col cols="6" style="text-align:center">
            <small>
              Comments
              <font-awesome-icon :icon="['fas', 'comment-dots']" />
              ({{ ann.commentList.comments.length - 1 }})
            </small>
          </b-col>
          <b-col cols="3">
            <div style="border-bottom:1px solid black; margin:0px 5px" :style="activeAnnotations.includes(ann) === true ? {borderColor:'#14BF98'}:{}"></div>
          </b-col>
        </b-row>

        <div v-for="(comm, idx) in ann.commentList.comments" :key="idx">
          <b-row v-if="idx !== 0" class="annotations row m-2 p-2 align-items-center" 
          style="border-radius:5px; background-color:#f2f2f2"
          v-bind:style="'opacity:' + ((hiddenAnnotations.includes(ann.id) || !selectedPeople.includes(ann.commentList.comments[0].meta.user_name)) ? '.3;' : '1;')"
          >
            <b-col class="pa-1 text-break">
              <div
              class="font-weight-bold mb-1"
              :class="comm.meta.user_name + '-color'"
              >
                {{ comm.meta.user_name }}
                <small>- {{comm.timeSince}}</small>
              </div>
              {{ comm.body }}
            </b-col>
            <b-col
            v-if="pluginOptions.meta.user_name === comm.meta.user_name
            || ['admin', 'owner'].includes(userRole) "
            cols="1"
            class="pa-0 ma-auto text-right"
            >
              <font-awesome-icon class="pointerEltVideo" style="color: red" :icon="['fas', 'trash']" title="Remove comment" @click="deleteComment(comm.id)" />
                <!-- <v-btn icon x-small @click="deleteComment(comm.id)">
                  <v-icon color="accent">mdi-delete</v-icon>
                </v-btn> -->
            </b-col>
          </b-row>
        </div>
        
        <div class="annotations pa-0"
        v-bind:style="'opacity:' + ((hiddenAnnotations.includes(ann.id) || !selectedPeople.includes(ann.commentList.comments[0].meta.user_name)) ? '.3;' : '1;')"
        >
          <b-button
            :id="'btn-' + ann.id"
            variant="msstreamorangesmall"
            block
            @click="answerComment(ann.id)"
          >
            Add a comment
            <font-awesome-icon
              :icon="['fas', 'comment-dots']"
              @click="answerComment(ann.id)"
            />
          </b-button>
        </div>

        <div :id="ann.id" class="d-none">
          <b-row class="m-0 mb-3 p-2 align-items-center" style="background-color:#f2f2f2">
            <b-col cols="10" id="" class="transition-ease-in-out p-1 pr-3 m-0">
              <b-form-textarea
                :id="'text-' + ann.id"
                class="annotation answers"
                solo
                label="Message"
                :rules="['Required']"
                hide-details
                clearable
                style="margin-top: 5px"
              ></b-form-textarea>
            </b-col>
            <b-col
              cols="2"
              class="transition-ease-in-out p-1"
              style="text-align: center"
            >
              <b-button variant="empty" @click="sendComment(ann.id)">
                <font-awesome-icon
                  style="color: #14bf98"
                  :icon="['fas', 'check']"
                />
              </b-button>
              <b-button variant="empty" @click="hideCommentSection(ann.id)">
                <font-awesome-icon
                  style="color: red"
                  :icon="['fas', 'times']"
                />
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js/dist/video.min.js";
import "video.js/dist/video-js.min.css";
import AnnotationComments from "@vireed/vjsac";
import io from "socket.io-client";
import vireedAnnotationService from "@/services/vireedAnnotation.service.js";
import Swal from "sweetalert2";
import "@/assets/js/videojs-quanteec-plugin";
import { BASE_URL, WS_VIREED } from "@/services/base-url";
import { EventBus } from "@/event-bus.js";
window.hlsSourceHandler.register(videojs);
var VideoMethods = new vireedAnnotationService();

var defaultSocketUrl = WS_VIREED;

export default {
  props: {
    playerOptions: {
      type: videojs.PlayerOptions,
      default() {
        return {};
      },
    },
    selectedPeople: {
      default() {
        return [];
      },
    },
    userRole: {
      default() {
        return "viewer";
      },
    },
    expand: {
      default() {
        return 1;
      },
    },
    roleChanged: {
      default() {
        return false;
      },
    },
  },
  name: "VideoPlayer",
  data() {
    let version = "-1";
    if (this.$route.params.version) {
      version = this.$route.params.version;
    }
    return {
      version: version,
      canEdit: false,
      player: null,
      plugin: null,
      projectId: this.$route.params.projectId,
      annotations: [],
      activeAnnotations: [],
      annVisible: false,
      annValue: "",
      pluginOptions: {},
      hiddenAnnotations: [],
      socket: null,
      canConnect: false,
      currentDate : new Date(null),
      
      isControlled:false,
      isControllingVideo:false,
      controlledBy:"",
      rangeCurrentAnnotation : {
        start:0,
        end:0,
      }      
    };
  },
  computed: {
    startRange(){
      return this.fancyDurationFormat(this.rangeCurrentAnnotation.start);      
    },
    endRange(){
      return this.fancyDurationFormat(this.rangeCurrentAnnotation.end);      
    }
  },

  methods: {
    fancyDurationFormat(number) {
    // Hours, minutes and seconds
        var hrs = ~~(number / 3600);
        var mins = ~~((number % 3600) / 60);
        var secs = ~~number % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";

        if (hrs > 0) {
          ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        if (mins > 0) {
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        }

        ret += "" + secs + "s";
        return ret;
    },

    selectAnnotation: function (ann) {
      VideoMethods.selectAnnotation(this, ann);
    },
    hoverAnnotation: function (annId, leave) {
      VideoMethods.hoverAnnotation(this, annId, leave);
    },
    hideAnnotation: function (annId) {
      VideoMethods.hideAnnotation(this, annId);
    },
    deleteAnnotation: function (annId) {
      VideoMethods.deleteAnnotation(this, annId);
    },
    deleteComment: function (commId) {
      VideoMethods.deleteComment(this, commId);
    },
    answerComment: function (annId) {
      VideoMethods.answerComment(annId);
    },
    hideCommentSection: function (annId) {
      VideoMethods.hideCommentSection(annId);
    },
    sendComment: function (annId) {
      VideoMethods.sendComment(this, annId);
    },
    addAnnotation: function () {
      VideoMethods.addAnnotation(this);
//      this.rangeCurrentAnnotation.start = 0;
//      this.rangeCurrentAnnotation.end = 0;
    },
    cancelAnnotationMode: function () {
      this.rangeCurrentAnnotation.start = 0;
      this.rangeCurrentAnnotation.end = 0;
      this.annValue = "";
      this.$emit("openannot");
      VideoMethods.cancelAnnotationMode(this);
    },
    annotationMode: function () {
      this.$emit("openannot");
      VideoMethods.annotationMode(this);
      if(this.player != null && this.player != undefined)
      {
        this.rangeCurrentAnnotation.start = this.player.currentTime();
        this.rangeCurrentAnnotation.end = this.rangeCurrentAnnotation.start;

      }
    },
    playerReady: function () {
      var user = this.$auth.getMyUser();
      var token = this.$auth.token();
      VideoMethods.playerReady(this, user, token);
    },
    pluginReady: function () {
      VideoMethods.pluginReady(this, io, Swal);
    },
    socketReady: function () {
      Vue.prototype.$socket = this.socket;

      if (this.player != null && this.player != undefined) {
        this.player.on("play", () => {
          if (this.isControllingVideo)
            this.socket.emit("play", this.player.currentTime(), this.version);
          //On envoyer un play à toutes les personnes connectées
        });

        this.player.on("pause", () => {
          if (this.isControllingVideo)
            this.socket.emit("pause", this.player.currentTime(), this.version);
          //On envoie un pause à toutes les personnes connectées
        });

        this.player.on("seeked", () => {
          if (this.isControllingVideo)
            this.socket.emit("seeked", this.player.currentTime(), this.version);
        });
      }
    },
    controlVideo: function () {
      this.player.pause();
      this.socket.emit(
        "takeControl",
        this.$auth.getMyUser().username,
        this.version,
        this.player.currentTime()
      );
      this.isControllingVideo = true;
      this.controlledBy = this.$auth.getMyUser().username;
    },
    releaseControlVideo: function () {
      this.socket.emit(
        "releaseControl",
        this.$auth.getMyUser().username,
        this.version
      );
      this.isControllingVideo = false;
      this.controlledBy = "";
    },
    toastVideo: function (message, append = false) {
      this.$bvToast.toast(message, {
        toaster: "b-toaster-bottom-center",
        solid: true,
        appendToast: append,
        autoHideDelay: 1000,
      });
    },
    //Fonction qui se déclenche lorsque l'on refresh ou ferme la page
    beforeunloadFn(e) {
      if (this.isControllingVideo) this.releaseControlVideo();
      VideoMethods.beforeDestroyExecutedMethod(this);
      Vue.prototype.$socket = undefined;
    },
    countAnnotationByUser(annotations) {
      var annotCount = {};
      annotations.forEach((annot) => {
        annot.comments.forEach((comm, index) => {
          if (comm.meta.user_name in annotCount) {
            if (index === 0) {
              annotCount[comm.meta.user_name].annotations += 1;
              if (annot.comments.length > 1)
                annotCount[comm.meta.user_name].annotationsWithComment += 1;
            } else annotCount[comm.meta.user_name].comments += 1;
          } else {
            let userCount = {
              annotations: 0,
              comments: 0,
              annotationsWithComment: 0,
            };

            if (index === 0) {
              userCount.annotations = 1;
              if (annot.comments.length > 1)
                userCount.annotationsWithComment += 1;
            } else userCount.comments = 1;

            annotCount[comm.meta.user_name] = userCount;
          }
        });
      });
      EventBus.$emit("newAnnotationCount", annotCount);
    },
  },
  created() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
  mounted() {
    if (this.playerOptions.sources !== undefined) {
      if (!videojs.getPlugins().annotationComments) {
        videojs.registerPlugin(
          "annotationComments",
          AnnotationComments(videojs)
        );
      }
      this.playerOptions.textTrackSettings = false;
      this.playerOptions.html5 = this.playerOptions.html5 || {
        nativeTextTracks: false,
      };
      this.playerOptions.html5.quanteec = {
        clientID: this.$auth.getMyUser().client,
      };

      this.player = videojs("vid-" + this.projectId, this.playerOptions);
      // this.player.snapshot();
      console.log()
      if (this.playerOptions.sources[0].src != "" && (this.player != null || this.player != undefined)) {
        console.log("On se connecte avec le plugin");
        if (this.socket != null || this.socket != undefined) {
          this.socket.disconnect();
          this.socket = undefined;
        }
        if(Vue.prototype.$socket != undefined)
        {
          Vue.prototype.$socket.disconnect();
          Vue.prototype.$socket = undefined;
        }
        this.player.ready(this.playerReady);
      } else {
        console.log("on se connecte sans plugin");
        if (this.socket != null || this.socket != undefined) {
          this.socket.disconnect();
          this.socket = undefined;
        }
            if(Vue.prototype.$socket != undefined)
    {
      Vue.prototype.$socket.disconnect();
      Vue.prototype.$socket = undefined;
    }
        VideoMethods.noPlugin(this, io, Swal);
      }
    } else {
      if (this.socket != null || this.socket != undefined) {
          this.socket.disconnect();
          this.socket = undefined;
      }
      console.log("on se connecte sans plugin");
      VideoMethods.noPlugin(this, io, Swal);
    }
  },
  beforeDestroy() {
    if (this.isControllingVideo) this.releaseControlVideo();
    VideoMethods.beforeDestroyExecutedMethod(this);
    if(Vue.prototype.$socket != undefined)
    {
      Vue.prototype.$socket.disconnect();
      Vue.prototype.$socket = undefined;
    }
  },
};

//

// export default {
//   name: 'vireedplayer',
//   data: function () {
//     return {
//         projectId: ''
//     }
//    },
//    mounted() {
//        this.projectId = this.$route.params['projectId'];
//    },
//    methods: {

//    }
// }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.commentList-enter-active,
.commentList-leave-active {
  transition: all 0.3s ease-in-out;
}

.commentList-enter, .commentList-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(20px);
}

.annButton {
  height: 25px !important;
  //color: var(--v-primary-base);
}

.annotations {
  min-height: 20%;
  padding: 5px;
  margin: 5px;
  border-radius: 5px;
}

.answers {
  margin-left: 5%;
}

.activeComment {
  border-radius: 5px;
  border : solid 1px #14BF98;
}

.inactiveComment {
  border-radius: 5px;
  border : solid 1px black;
}

.commList {
  max-height: calc(100vh - 100px);
  overflow: scroll;
}
</style>